import KT01BaseLayout from "general/components/BaseLayout/KT01BaseLayout";
import { Route, Routes } from "react-router-dom";
import LandlordReconciliationListScreen from "./screens/LandlordReconciliationListScreen";
import LandlordReconciliationDetailScreen from "./screens/LandlordReconciliationDetailScreen";
// import AgencySaleOrderListScreen from "features/Agency/screens/AgencySaleOrderListScreen";

function LandlordReconciliationReport(props) {
    return (
        <KT01BaseLayout isFullScreen={true}>
            <div className="container-fluid px-0 pb-4">
                <Routes>
                    <Route
                        path=""
                        element={
                            <LandlordReconciliationListScreen />
                        }
                    />
                    <Route path="/:reconciliationId" element={<LandlordReconciliationDetailScreen />} />
                    <Route path="*" element={<>Not found</>} />
                </Routes>
            </div>
        </KT01BaseLayout>
    );
}

export default LandlordReconciliationReport;
